/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = undefined;
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    a: "a",
    ol: "ol",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Usage"
    }), "\n", _jsxs(_components.p, {
      children: ["Here we go into the specifics of usage. We assume you've gone over the ", _jsx(_components.a, {
        href: "./concepts",
        children: "concepts section"
      }), ".\nIf you would rather look at reference examples you may start with the\n", _jsx(_components.a, {
        href: "https://github.com/broadmindcloud/websemaphore-examples",
        children: "WebSemaphore examples"
      }), " on github."]
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Make sure you've gone through the ", _jsx(_components.a, {
          href: "/docs/v1/setup",
          children: "setup section"
        }), "."]
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/v1/usage/install-client",
          children: "Install the client library"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/v1/usage/rest",
          children: "HTTP/REST Usage"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/v1/usage/websockets",
          children: "Websockets Usage"
        })
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
